import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  document,
  heroIconsDocSearch,
  heroIconsPayments,
  heroIconsSettings,
  heroiconsArrowTopRightOnSquare,
} from '@ld.consumer-portal/data-uri';
import { ENVIRONMENT } from '@ld.consumer-portal/models';
import { BrowserService } from '@ld.consumer-portal/utils';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

interface ComingSoonFeature {
  id: string;
  icon: string;
  labelKey: string;
}

@Component({
  selector: 'ld-origination-coming-soon-card',
  imports: [SvgIconComponent, TranslocoDirective],
  templateUrl: './origination-coming-soon-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OriginationComingSoonCardComponent {
  private readonly browserService = inject(BrowserService);
  private readonly env = inject(ENVIRONMENT);

  protected readonly features: ComingSoonFeature[] = [
    { id: 'make-payments', icon: heroIconsPayments, labelKey: 'originationComingSoonFeatureMakePayments' },
    { id: 'loan-details', icon: heroIconsDocSearch, labelKey: 'originationComingSoonFeatureLoanDetails' },
    { id: 'manage-account', icon: heroIconsSettings, labelKey: 'originationComingSoonFeatureManageAccount' },
    { id: 'documents', icon: document, labelKey: 'originationComingSoonFeatureDocuments' },
  ];

  protected readonly externalLinkIcon = heroiconsArrowTopRightOnSquare;

  protected onContinue(): void {
    const mobileWebUrl = this.env.appSettings.oidcSettings?.baseUrl ?? '/';
    void this.browserService.openUrl(mobileWebUrl);
  }
}
